import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Note: StrictMode removed for better noVNC WebSocket compatibility
// Re-enable for development debugging if needed
createRoot(document.getElementById('root')!).render(
  <App />
)
